import axios from 'axios';
import FormData from 'form-data';
import { getAuthToken } from "./authConfig"
import { GetServiceClear } from "./clearService"

const apiUrl = 'https://portal.almalcapital.com/api';
// const apiUrl = 'https://almalcapital.xilligence.com:3666';
// const apiUrl = 'https://192.168.50.6:3009';
// const apiUrl = 'http://localhost:3006/api';
// const apiUrl = 'https://aipro.xilligence.com:5763/api';
// const apiUrl = 'https://almal.xilligence.com/api';

export async function callingAPIWithoutAuth(postData, functionName, requestType = 'post') {

    const url = `${apiUrl}/${functionName}`;
    const headers = {
        'x-version': '1.0',
    };
    const options = { headers };
    try {
        let res;
        const reqType = requestType.toLowerCase();

        if (reqType === 'post') {
            res = await axios.post(url, postData, options);
        } else if (reqType === 'put') {
            res = await axios.put(url, postData, options);
        } else if (reqType === 'patch') {
            res = await axios.patch(url, postData, options);
        }
        // Check the status
        if (res.status >= 200 && res.status <= 299) {
            return { status: res.status, data: res.data };
        } else {
            throw new Error(`Request failed with status code: ${res.status}`);
        }
    } catch (error) {
        console.error("Error during API call:", error);
        throw error;
    }
}

export async function uploadProfilePicture(file, userId, functionName) {
    const formData = new FormData();
    formData.append('file', file); // Append the file
    formData.append('userId', userId); // Append userId
    const url = `${apiUrl}/${functionName}`; // Define the specific endpoint for uploading
    //  const jwtToken = getAuthToken()
    const headers = {
        Authorization: `Bearer ${window.sessionStorage.getItem("accessToken")}`,
        'x-version': '1.0',
        // 'Content-Type': 'multipart/form-data',
    };
    try {
        const response = await axios.post(url, formData, { headers }); // Make the POST request

        console.log("🚀 ~ uploadProfilePicture ~ response:", (url, formData, { headers }))
        // Check the status
        if (response.status >= 200 && response.status <= 299) {
            return { status: response.status, data: response.data };
        } else {
            throw new Error(`Request failed with status code: ${response.status}`);
        }
    } catch (error) {
        console.error('Error during file upload:', error);
        throw error; // Re-throw the error for handling in the calling component
    }
}

function handleSessionExpired() {
    GetServiceClear();
    window.sessionStorage.removeItem("accessToken");
    window.sessionStorage.removeItem("refreshToken");
    window.location.href = "/";
}


let isRefreshing = false;
let refreshSubscribers = [];

// Notify all waiting requests once refresh is done
function onRrefreshed(newAccessToken) {
    refreshSubscribers.forEach((cb) => cb(newAccessToken));
    refreshSubscribers = [];
}

async function performRequest(url, reqType, postData, token) {
    const headers = {
        Authorization: `Bearer ${token}`,
        "x-version": "1.0",
    };
    const options = { headers };

    if (reqType === "post") return axios.post(url, postData, options);
    if (reqType === "put") return axios.put(url, postData, options);
    if (reqType === "patch") return axios.patch(url, postData, options);

    throw new Error(`Unsupported request type: ${reqType}`);
}

async function performRequestForgot(url, reqType, postData, token) {
    const headers = {
        Authorization: `Bearer ${token}`,
        "x-version": "1.0",
    };
    const options = { headers };
    console.log('options....performRequestForgot.........', options);

    if (reqType === "post") return axios.post(url, postData, options);
    if (reqType === "put") return axios.put(url, postData, options);
    if (reqType === "patch") return axios.patch(url, postData, options);

    throw new Error(`Unsupported request type: ${reqType}`);
}

export default async function callingAPI(
    postData,
    functionName,
    requestType = "post"
) {
    const url = `${apiUrl}/${functionName}`;
    const accessToken = window.sessionStorage.getItem("accessToken");
    const refreshToken = window.sessionStorage.getItem("refreshToken");
    const reqType = requestType.toLowerCase();

    try {
        // Normal request
        const res = await performRequest(url, reqType, postData, accessToken);
        return { status: res.status, data: res.data };
    } catch (error) {
        // If token expired
        if (error.response?.status === 401 && refreshToken) {
            if (!isRefreshing) {
                isRefreshing = true;

                try {
                    const headers = {
                        "x-version": "1.0",
                    };
                    const options = { headers };

                    const refreshResponse = await axios.post(
                        `${apiUrl}/user/refresh`,
                        { refreshToken },
                        options
                    );

                    const { accessToken: newAccessToken, refreshToken: newRefreshToken } =
                        refreshResponse.data.data;

                    // Save new tokens
                    window.sessionStorage.setItem("accessToken", newAccessToken);
                    window.sessionStorage.setItem("refreshToken", newRefreshToken);

                    isRefreshing = false;
                    onRrefreshed(newAccessToken); // notify waiting requests
                } catch (err) {
                    isRefreshing = false;
                    handleSessionExpired();
                    throw err;
                }
            }

            // Queue the failed request until refresh completes
            return new Promise((resolve, reject) => {
                refreshSubscribers.push(async (newAccessToken) => {
                    try {
                        const res = await performRequest(url, reqType, postData, newAccessToken);
                        resolve({ status: res.status, data: res.data });
                    } catch (err) {
                        reject(err);
                    }
                });
            });
        }

        throw error;
    }
}

export async function callingAPIWithoutAuthForgotPassword(
    postData,
    functionName,
    requestType = "post"
) {
    const url = `${apiUrl}/${functionName}`;
    const resetToken = window.sessionStorage.getItem("resetToken");
    console.log('url.....callingAPIWithoutAuthForgotPassword.......', url);
    console.log('resetToken.....callingAPIWithoutAuthForgotPassword.......', resetToken);
    const reqType = requestType.toLowerCase();

    try {
        // Normal request
        const res = await performRequestForgot(url, reqType, postData, resetToken);
        return { status: res.status, data: res.data };
    } catch (error) {
        // if (error?.response?.status === 401) {
        //     sessionStorage.removeItem("resetToken");
        // }
        // console.error(
        //     "Forgot-password API error:",
        //     error?.response?.status || error.message
        // );
        throw error;
    }
}



